/**
 * defa.collections.batteryAlerts
 * A Collection of BatteryAlert
 * @version 1.2.0
 */
import BatteryAlert from './model-battery-alert';

const BatteryAlerts = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : BatteryAlert,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default BatteryAlerts;